import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { Editor } from 'tinymce';

declare let tinymce: any;

@Injectable()
export class TinyMCEPluginsService {
  constructor(private _translateService: TranslateService,
              private _rxEmitter: RxEmitter) { }

  public addPushLinkPlugin(): void {
    if (tinymce.PluginManager.get('pushLink')) {
      return;
    }
    const rxEmitter = this._rxEmitter;
    const tooltipText = this._translateService.instant('bcEditor.toolbar.pushLink');
    tinymce.PluginManager.add('pushLink', function (editor) {
      editor.ui.registry.addButton('pushLink', {
        icon: 'link-push',
        tooltip: tooltipText,
        onAction: () => {
          rxEmitter.send(`${MessageBusEvents.TogglePushLinkDialog}${editor.id}`, null);
        }
      });
    });
  }

  public addInsertImagePlugin(): void {
    if (tinymce.PluginManager.get('insertImage')) {
      return;
    }
    const tooltipText = this._translateService.instant('bcEditor.toolbar.imageInsertLink');
    const rxEmitter = this._rxEmitter;
    tinymce.PluginManager.add('insertImage', function (editor) {
      editor.ui.registry.addButton('insertImage', {
        icon: 'image',
        tooltip: tooltipText,
        onAction: () => {
          rxEmitter.send(`${MessageBusEvents.ToggleInsertImageDialog}${editor.id}`, null);
        }
      });
    });
  }

  public setFileUploadButtonDisabled(editor: Editor, isDisabled: boolean) {
    editor.fire('setFileUploadButtonDisabled', { isDisabled });
  }

  public addDynamicFileUploadButton(editor: Editor, showFileUpload: boolean): void {
    const tooltipText: string = this._translateService.instant('bcEditor.toolbar.uploadFile');
    editor.ui.registry.addButton('fileUpload', {
      icon: 'upload',
      tooltip: tooltipText,
      onAction: () => {
        this._rxEmitter.send(MessageBusEvents.OpenFileSelect, null);
      },
      onSetup: (buttonApi) => {
        editor.on('setFileUploadButtonDisabled', (event) => {
          buttonApi.setDisabled(event.isDisabled);
        });

        buttonApi.setDisabled(!showFileUpload);

        editor.fire('fileUploadButtonSetupReady');

        return () => {
          editor.off('setFileUploadButtonDisabled');
        };
      }
    });
  }
}
